import { merge } from 'lodash';

import { translations as demoVariantTranslations } from '@dreryk/demo-variant-frontend';
import { translations as drerykwebMainTranslations } from '@dreryk/drerykweb-main-frontend';
import { translations as drerykwebSecurityTranslations } from '@dreryk/egabinet-security-frontend';
import { initializeI18n, translations as reactCommonComponentsTranslations } from '@dreryk/react-common';
import { translations as drerykwebReactComponentsTranslations } from '@dreryk/react-components';
import { translations as calendarTranslations } from '@dreryk/react-calendar';

import { translations as egabinetDocplannetTranslations } from '~legacy.docplanner';
import { translations as egabinetInvoiceTranslationKeys } from '~legacy.invoice';
import { translations as egabinetOnlinePaymentsTranslationKeys } from '~legacy.online-payments';
import { translations as medicineDatabasePharmindexTranslations } from '~legacy.medicine-database-pharmindex';
import { translations as drerykwebP1Translations } from '~legacy.p1';
import { translations as patientTranslations } from '~legacy.patient';
import { translations as egabinetPatientPortalTranslations } from '~legacy.patient-portal';
import { translations as egabinetPersonnelTranslations } from '~legacy.personnel';
import { translations as egabinetPrivateMedicalServiceTranslations } from '~legacy.private-medical-service';
import { translations as egabinetStatisticsTranslations } from '~legacy.statistics';
import { translations as visitTranslations } from '~legacy.visit';
import { translations as dashboardTranslations } from '~legacy.dashboard';
import { translations as videoConsultationTranslations } from '~libs.desktop.video-consultation';
import { translations as visitCancelTranslations } from '~libs.desktop.shared.visit-cancel';
import { translations as appointmentsTimetableTranslations } from '~libs.desktop.shared.appointments-timetable';
import { translations as educationalMaterialTranslations } from '~libs.desktop.shared.educational-material';
import { translations as patientGroupsTranslations } from '~libs.desktop.patient-groups';
import { translations as patientSimpleCreateActionTranslations } from '~libs.desktop.shared.patient-simple-create-action';
import { translations as waitlistTranslations } from '~libs.desktop.pages.waitlist';
import { translations as practitionerSafePresenterTranslations } from '~libs.desktop.shared.practitioner-safe-presenter';
import { translations as desktopSharedPatientTranslations } from '~libs.desktop.shared.patient';
import { translations as sharedPatientTranslations } from '~libs.shared.patient';
import { translations as sharedPatientAuthorizationTranslations } from '~libs.desktop.shared.patient-authorization';
import { translations as sharedAccountTranslations } from '~libs.desktop.shared.account';
import { translations as adamedExpertTranslations } from '~libs.desktop.adamed-expert';
import { translations as patientMedicalInformationTranslations } from '~libs.desktop.patient-medical-information';
import { translations as groupSessionsTranslations } from '~libs.desktop.group-sessions';
import { translations as emergencyNotificationTranslations } from '~libs.desktop.emergency-notification';
import { translations as aiAssistantTranslations } from '~libs.desktop.ai-assistant';
import { translations as desktopPatientPrescriptionHistoryTranslations } from '~libs.desktop.shared.patient-prescription-history';
import { translations as desktopSharedMedicineTranslations } from '~libs.desktop.shared.medicine';
import { translations as desktopSharedVisitTranslations } from '~libs.desktop.shared.visit';
import { translations as medicalDataConfidentialityTranslations } from '~libs.desktop.shared.medical-data-confidentiality';

// Moment issue: https://github.com/moment/moment/issues/5926
import 'moment/dist/locale/pl';

import { translations as appTranslations } from './translations';
import { systemActivityTranslations } from './systemActivity/translations';

export const initializeTranslations = async (): Promise<void> => {
   await initializeI18n({
      locale: 'pl',
      timezone: 'Europe/Warsaw',
      resources: merge(
         {},
         reactCommonComponentsTranslations,
         drerykwebMainTranslations,
         ...visitTranslations,
         drerykwebReactComponentsTranslations,
         medicineDatabasePharmindexTranslations,
         drerykwebP1Translations,
         ...patientTranslations,
         egabinetPersonnelTranslations,
         drerykwebSecurityTranslations,
         demoVariantTranslations,
         egabinetStatisticsTranslations,
         egabinetPrivateMedicalServiceTranslations,
         appTranslations,
         egabinetDocplannetTranslations,
         egabinetPatientPortalTranslations,
         egabinetInvoiceTranslationKeys,
         egabinetOnlinePaymentsTranslationKeys,
         calendarTranslations,
         dashboardTranslations,
         videoConsultationTranslations,
         visitCancelTranslations,
         appointmentsTimetableTranslations,
         educationalMaterialTranslations,
         patientGroupsTranslations,
         patientSimpleCreateActionTranslations,
         waitlistTranslations,
         practitionerSafePresenterTranslations,
         sharedPatientTranslations,
         desktopSharedPatientTranslations,
         sharedPatientAuthorizationTranslations,
         sharedAccountTranslations,
         adamedExpertTranslations,
         patientMedicalInformationTranslations,
         groupSessionsTranslations,
         emergencyNotificationTranslations,
         systemActivityTranslations,
         aiAssistantTranslations,
         desktopPatientPrescriptionHistoryTranslations,
         desktopSharedMedicineTranslations,
         desktopSharedVisitTranslations,
         medicalDataConfidentialityTranslations
      ),
   });
};
